import React from "react";
import { motion } from "framer-motion";

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.08, ease: [0.2, 0.7, 0.2, 1] },
  }),
};

export function Reveal({ children, delay = 0, className = "", as = "div", ...rest }) {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      custom={delay}
      variants={fadeUp}
      className={className}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export function Overline({ children, className = "" }) {
  return <div className={`overline ${className}`}>{children}</div>;
}

export function SectionHeader({ overline, title, subtitle, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      <Reveal>
        <Overline>{overline}</Overline>
      </Reveal>
      <Reveal delay={1}>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-[56px] tracking-tight mt-4 leading-[1.05] text-brand-ink">
          {title}
        </h2>
      </Reveal>
      {subtitle ? (
        <Reveal delay={2}>
          <p className="mt-6 text-brand-ink/70 text-lg md:text-xl leading-relaxed font-light">{subtitle}</p>
        </Reveal>
      ) : null}
    </div>
  );
}
